import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import ChatItem from './ChatItem';
import Select from 'react-select';
import ConciergeController, { ConciergeChatType } from '../../../controller/ConciergeController';
import DetectorController, {
  AreaListType,
  ChatDetailType,
  ChatRoomType,
  HotelListType,
} from '../../../controller/DetectorController';
import toast from 'react-hot-toast';
import ChatDetailModal from '../../../components/modal/ChatDetailModal';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

let interval: any;

const CSChatList = () => {
  const params = useParams();
  const storeId = params.store_id;

  const navigate = useNavigate();
  //0: NEW , 1:답변완료
  const [status, setStatus] = useState<number>(0);

  const [chatList, setChatList] = useState<ChatRoomType[]>([]);

  const [isMobile, setIsMobile] = useState<boolean>(false);

  const [hotelList, setHotelList] = useState<HotelListType[]>([]);
  const [selectedHotel, setSelectedHotel] = useState<HotelListType | null>(null);

  const [areaList, setAreaList] = useState<AreaListType[]>([]);
  const [selectedArea, setSelectedArea] = useState<AreaListType | null>(null);

  const [roomList, setRoomList] = useState<AreaListType[]>([]);
  const [selectedRoom, setSelectedRoom] = useState<AreaListType | null>(null);

  const [visibleDetail, setVisibleDetail] = useState<boolean>(false);

  const [selectedChat, setSelectedChat] = useState<ChatRoomType | null>(null);
  const [chatDetail, setChatDetail] = useState<ChatDetailType[]>([]);

  const handleResize = () => {
    if (window.innerWidth > 900) setIsMobile(false);
    else setIsMobile(true);
  };

  const getChatDetails = async (selectedChat: ChatRoomType | null) => {
    try {
      if (selectedChat) {
        const oParams = {
          cs_id: selectedChat.cs_id,
          reader_type: 'ADMIN',
        };
        const oResponse = await DetectorController.getChats(oParams);
        if (oResponse && oResponse.data) {
          const oRes = oResponse.data;
          if (oRes && oRes.data) {
            setChatDetail([...oRes.data.chats]);
            setVisibleDetail(true);
          }
        }
      }
    } catch (e) {
      console.error('err => ', e);
    }
  };

  // API 호출
  const getHotelList = async () => {
    try {
      const response = await DetectorController.getHotelList();

      if (response && response.data) {
        const formattedHotelList = [
          {
            value: '전체보기',
            label: '전체보기',
            store_id: undefined,
            user_id: undefined,
            bcode_list: [],
          },

          ...response.data.data.map((item: any) => ({
            value: item.store_name,
            label: item.store_name,
            store_id: item.store_id,
            user_id: item.user_id,
            bcode_list: item.bcode_list,
          })),
        ];
        setHotelList(formattedHotelList);
        if (storeId) {
          const filteredStore = formattedHotelList.find(
            (item: any) => item.store_id === Number(storeId),
          );
          console.log('filteredStore', formattedHotelList, storeId, filteredStore);
          if (filteredStore) {
            setSelectedHotel(filteredStore);
          }
        } else if (selectedHotel === null) {
          setSelectedHotel(formattedHotelList[0] || null);
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  const getAreaFloorAndRoomByStoreId = async () => {
    try {
      if (selectedHotel) {
        const oParams = {
          store_id: selectedHotel.store_id,
        };

        const response = await DetectorController.getAreaFloorAndRoomByStoreId(oParams);

        if (response && response.data) {
          const oRes = response.data;
          if (oRes.data && oRes.data.floorAndRoomMetaData) {
            const formattedAreaList = response.data.data.floorAndRoomMetaData.map((item: any) => ({
              value: item.floor,
              label: item.floor,
              store_id: selectedHotel.store_id,
              room: item.room,
            }));
            setAreaList(formattedAreaList);
          }
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  const getChatRoomList = async () => {
    try {
      if (selectedHotel) {
        const oParams = {
          contact_person_type: 'ADMIN',
          contact_person: '관리자',
          is_finished: status === 1,
          hotel_id: selectedHotel.store_id,
        };

        const response = await DetectorController.getChatRoomList(oParams);

        if (response && response.data) {
          const oRes = response.data;
          if (oRes.data && oRes.data.chatRooms) {
            setChatList([...oRes.data.chatRooms]);
          }
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  const getAreaRoom = () => {
    if (selectedHotel && selectedArea && selectedArea.room) {
      const formattedRoomList = selectedArea.room.map((item: any) => ({
        value: item.area_id,
        label: item.name,
        store_id: selectedHotel.store_id,
      }));
      setRoomList(formattedRoomList);
    }
  };

  const createChatRoom = async () => {
    try {
      if (selectedHotel && selectedArea && selectedRoom) {
        const oParams = {
          area_id: selectedRoom.value,
          contact_person: '관리자',
          contact_person_type: 'ADMIN',
        };

        const response = await DetectorController.createChatRoom(oParams);

        if (response && response.data) {
          const oRes = response.data;
          if (oRes.data) {
            setSelectedChat({
              store_name: selectedHotel.label,
              area_name: selectedRoom.label,
              contact_person: '관리자',
              cs_id: oRes.data.cs_id,
              is_finished: 0,
              store_id: null,
              order_id: null,
              order_seq: null,
              latest_chat_time: new Date().toString(),
              latest_chat: '',
              unread_count: 0,
            });
          } else {
            toast.error('기기가 연결되지 않은 객실이에요');
          }
        } else {
          toast.error('기기가 연결되지 않은 객실이에요');
        }
      } else {
        toast.error('객실을 확인해주세요');
      }
    } catch (err) {
      toast.error('기기가 연결되지 않은 객실이에요');
      console.log('err-->', err);
    }
  };

  const handleChangeHotel = (selectedOption: HotelListType | null) => {
    setSelectedHotel(selectedOption);
  };

  const handleChangeArea = (selectedOption: AreaListType | null) => {
    setSelectedArea(selectedOption);
  };

  const handleChangeRoom = (selectedOption: AreaListType | null) => {
    setSelectedRoom(selectedOption);
  };

  const openChatDetail = (chat: ChatRoomType) => {
    setSelectedChat(chat);
  };

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (selectedHotel) {
      setSelectedArea(null);
      setSelectedRoom(null);
      if (selectedHotel.store_id) {
        getAreaFloorAndRoomByStoreId();
      } else {
        setAreaList([]);
        setRoomList([]);
      }
      getChatRoomList();
    }
  }, [selectedHotel]);

  useEffect(() => {
    getAreaRoom();
  }, [selectedArea]);

  useEffect(() => {
    getChatRoomList();
  }, [status]);

  useEffect(() => {
    getHotelList();
  }, []);

  useEffect(() => {
    if (selectedChat) {
      getChatDetails(selectedChat);
      console.log('interval', interval);
      if (!interval) {
        interval = setInterval(() => {
          getChatDetails(selectedChat);
        }, 10000);
      }
    } else {
      console.log('clear');
      clearInterval(interval);
      interval = null;
      console.log('interval clear', interval);
    }
  }, [selectedChat]);

  useEffect(() => {
    if (!visibleDetail) {
      getChatRoomList();
      setSelectedChat(null);
    }
  }, [visibleDetail]);

  return (
    <>
      <Style>
        <div className="wrap">
          <div className={'contentContainer'}>
            <button className="backButton" onClick={() => navigate('/dashboard')}>
              <img src={`${process.env.PUBLIC_URL}/svg/ic_home.svg`} alt="뒤로가기버튼" />
            </button>
            <div className="selectWrap">
              <Select options={hotelList} value={selectedHotel} onChange={handleChangeHotel} />
              <div className="row">
                <div className="roomSelectWrap">
                  <Select options={areaList} value={selectedArea} onChange={handleChangeArea} />
                </div>
                <div className="roomSelectWrap">
                  <Select options={roomList} value={selectedRoom} onChange={handleChangeRoom} />
                </div>
                <button onClick={createChatRoom}>
                  <img src={`${process.env.PUBLIC_URL}/svg/ic_message.svg`} alt="send" />
                </button>
              </div>
            </div>
            <div className="statusWrap">
              <div
                className={`statusItem ${status === 0 && 'active left'}`}
                onClick={() => setStatus(0)}>
                <h3>NEW</h3>
              </div>
              <div
                className={`statusItem ${status === 1 && 'active right'}`}
                onClick={() => setStatus(1)}>
                <h3>답변완료</h3>
              </div>
            </div>
            <RenderOrderList
              chatList={chatList}
              isMobile={isMobile}
              openChatDetail={openChatDetail}
            />
          </div>
        </div>
        {selectedChat && (
          <ChatDetailModal
            isVisible={visibleDetail}
            setVisible={setVisibleDetail}
            roomName={selectedChat.area_name}
            chatDetail={chatDetail}
            isMobile={isMobile}
            chat={selectedChat}
            setChatDetail={setChatDetail}
            status={status}
            getChatDetails={getChatDetails}
          />
        )}
      </Style>
    </>
  );
};

const RenderOrderList = (oProps: {
  chatList: ChatRoomType[];
  isMobile: boolean;
  openChatDetail: (chat: ChatRoomType) => void;
}) => {
  return oProps.chatList.length === 0 ? (
    <div className="noDataListWrap">
      <div className="title">
        <h3>상담내역이 없습니다</h3>
      </div>
    </div>
  ) : (
    <div className="chatListWrap">
      {oProps.chatList.map((chat, index) => {
        return (
          <ChatItem
            key={index}
            chat={chat}
            isMobile={oProps.isMobile}
            openChatDetail={oProps.openChatDetail}
          />
        );
      })}
    </div>
  );
};

export default CSChatList;

const Style = styled.div`
  /* contentContainer */
  .wrap {
    flex: 1;
    display: flex;
    justify-content: center;
    min-height: 100dvh;
    background: #f7f7f7;
  }

  .contentContainer {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    width: 800px;
    min-height: 100dvh;
    height: 100%;
    padding: 4% 2%;
    background: #ffffff;
    border-radius: 10px;
    .backButton {
      padding-left: 20px;
      width: fit-content;
    }
  }

  .selectWrap {
    padding: 20px;
    border: 1px solid #e9e9e9;
    border-radius: 10px;
    margin-bottom: 20px;
    .row {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 12px;
      padding-top: 12px;
      .roomSelectWrap {
        width: 30%;
      }
    }
    button {
      display: flex;
      align-items: center;
      margin-left: auto;
      margin-right: 0;
      border: none;
      background: #4dd2ae;
      border-radius: 5px;
      padding: 8px 24px;
      img {
        height: 20px;
      }
    }
  }

  /* statusWrap */
  .statusWrap {
    display: flex;
    margin: 0 10px;
    border-radius: 50px;
    background: #f7f7f7;
    border: 1px solid #e5e5e5;

    .statusItem {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      justify-content: center;
      cursor: pointer;
      padding: 18px;
      border-radius: 50px;
      background: #f7f7f7;

      h3 {
        font-size: 20px;
        line-height: 24px;
        color: #a7a7a7;
        font-weight: 600;
      }
    }
    .statusItem.active {
      padding: 13px;
      border: 5px solid #f7f7f7;
      background: #4dd2ae;

      h3 {
        color: #ffffff;
      }
    }
  }

  /* orderWrap */
  .orderWrap {
    background: #fff;
    overflow-y: auto;
    width: 100%;
    height: 100%;

    .orderTitle {
      /* position: sticky;
      margin-top: 1%;
      margin-bottom: auto;
      z-index: 3; */
      top: 0;
      position: sticky;
      width: 100%;
      display: flex;
      background: #ffffff;
      align-items: center;
      justify-content: flex-start;
      padding: 8px 0 8px 3vw;
      gap: 6px;
      z-index: 10;

      .dateButton {
        padding: 8px 36px;
        background: #fff;
        border-radius: 5px;
        color: #333333;
        font-size: 16px;
        line-height: 20px;
        font-weight: 600;
        border: 1px solid #999999;
      }
      .dateButton.active {
        background: #333;
        color: #ffffff;
        border: 1px solid #000000;
      }
    }
  }

  .noDataListWrap {
    flex: 1;
    max-height: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-self: center;

    .title {
      h3 {
        font-size: 20px;
        line-height: 24px;
        color: #999999;
        font-weight: 500;
      }
    }
    .titleIcon {
      clear: both;
    }
  }

  /* chatListWrap */
  .chatListWrap {
    flex: 1;
    max-height: 80%;
    overflow-y: auto;
  }

  @media (max-width: 900px) {
    .contentContainer {
      border-radius: 10px;
    }

    .statusWrap {
      margin: 0 10px;
      border-radius: 50px;
      background: #f7f7f7;
      border: 1px solid #e5e5e5;

      .statusItem {
        padding: 14px;
        border-radius: 50px;
        background: #f7f7f7;
        h3 {
          font-size: 20px;
        }
      }
      .statusItem.active {
        padding: 9px;
        border: 5px solid #f7f7f7;
        background: #4dd2ae;
        h3 {
          color: #ffffff;
        }
      }
    }
  }
`;
